export const getFileType = (fileName = '') => {
  const ext = fileName.split('.').pop()?.toLowerCase();

  if (['mp4', 'webm', 'ogg', 'mov'].includes(ext)) return 'video';
  if (['mp3', 'wav', 'aac', 'ogg'].includes(ext)) return 'audio';
  if (ext === 'pdf') return 'pdf';

  return 'image';
};
